import { render, staticRenderFns } from "./IncidentReport.vue?vue&type=template&id=5d20a927&"
import script from "./IncidentReport.vue?vue&type=script&lang=js&"
export * from "./IncidentReport.vue?vue&type=script&lang=js&"
import style0 from "./IncidentReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports